<div class="spinner-all">
  <div class="global-loader__spinner page-loader__spinner">
    <svg class="loader__spinner" viewBox="25 25 50 50">
      <circle class="loader__path" cx="50" cy="50" r="20" fill="none" stroke-width="3.5" stroke-miterlimit="150" />
    </svg>
  </div>
</div>